<template>
  <section class="title">
    <v-container fluid fill-height class="title__content my-auto">
      <v-row justify="space-around" style="max-width: 1100px;" class="mx-auto fill-height"
             align-content="center">
        <v-col align-self="center" class="title__contentText" cols="6">
          <p class="text-h4 font-weight-black mb-0">{{ title }}</p>
          <p class="text-h5 mb-0" v-if="subTitle">{{ subTitle }}</p>
        </v-col>
        <v-col align-self="center" align="right" cols="6">
          <v-img :src="require(`../assets/${img}`)" height="10vh" contain width="10vh"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    img: {
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  &__content {
    background-color: #ecf9fd;
    height: 15vh;
  }

  &__contentText {
    color: #012169;
  }
}
</style>